// SECURITY NOTE: the access token is persisted in localStorage, which is
// readable by any script running on the page (so it is exposed to XSS). This is
// an accepted trade-off for the current SPA + bearer-token setup. The more
// secure alternative is an httpOnly, Secure, SameSite cookie issued by the
// backend; moving to that requires backend changes and is tracked separately.
const TOKEN_KEY = 'accessToken';
const SIGNED_KEY = 'isSigned';

// Lightweight observable so React can react to session changes in the same tab
// (localStorage writes don't fire `storage` events in the originating tab).
type Listener = () => void;
const listeners = new Set<Listener>();

function emit(): void {
  listeners.forEach((listener) => listener());
}

export function subscribe(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function getToken(): string | null {
  const token = localStorage.getItem(TOKEN_KEY);
  return token && token !== '' ? token : null;
}

export function isSigned(): boolean {
  return localStorage.getItem(SIGNED_KEY) === 'true';
}

export function setSession(token: string): void {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(SIGNED_KEY, 'true');
  emit();
}

export function clearSession(): void {
  localStorage.setItem(TOKEN_KEY, '');
  localStorage.setItem(SIGNED_KEY, 'false');
  emit();
}
